import { useEffect, useState } from "react"
import Input from "../../../components/Input"
import Popup from "../../../components/Popup"
import CropPopup from "../../../components/CropPopup"
import { IoAdd, IoAddCircle, IoRemoveCircle } from "react-icons/io5"
import { authAxios } from "../../../helpers/axios"
import { ErrorToast } from "../../../helpers/toasters"
import Select from "../../../components/Select"
import SmallPopup from "../../../components/SmallPopup"

export default function DeleteTea({id,onSubmit,onClose,submitting})
{
    return <><SmallPopup submitting={submitting} size="sm" title={'Delete Tea'} submitTitle={'Delete'} onClose={onClose} formName={'deleteTea'}>
        <form onSubmit={(e)=>onSubmit(e)} id={'deleteTea'} className='w-full'>
            <div className="col-span-4">
                <p className="text-sm">Are you sure you want to delete this raw tea?</p>
            </div>
        </form>
    </SmallPopup>
    </>
}
